// removed by extract-text-webpack-plugin
module.exports = {"list":"src-components-PrimaryNavigation----PrimaryNavigation-module---list---2wgCY","search-icon-wrap":"src-components-PrimaryNavigation----PrimaryNavigation-module---search-icon-wrap---1aXnn","search-icon":"src-components-PrimaryNavigation----PrimaryNavigation-module---search-icon---2nXGy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PrimaryNavigation/PrimaryNavigation.module.scss
// module id = 1198
// module chunks = 114276838955818